module.exports = __webpack_public_path__ + "static/media/folder.41787206.jpg";